import { Separator as SeparatorPrimitive } from 'radix-ui';

import { cn } from '@components/primitives/utilities';

import css from './styles.module.css';

const dashArray = {
  solid: 'none',
  dashed: '4 4',
  dotted: '0.5 4',
};

export interface SeparatorProps {
  className?: string;
  variant?: keyof typeof dashArray;
  orientation?: 'horizontal' | 'vertical';
  /** Keeps the separator role, for a line that carries meaning of its own. */
  decorative?: boolean;
}

export function Separator({
  className,
  variant = 'solid',
  orientation = 'horizontal',
  decorative = true,
}: SeparatorProps) {
  const vertical = orientation === 'vertical';

  return (
    <SeparatorPrimitive.Root
      asChild
      orientation={orientation}
      decorative={decorative}
    >
      {/* An SVG, not a border: CSS dashes give no dash geometry or round caps. */}
      <svg
        className={cn(css.separator, className)}
        data-variant={variant}
        viewBox={vertical ? '0 0 2 100' : '0 0 100 2'}
        preserveAspectRatio="none"
      >
        <path
          d={vertical ? 'M 1 0 L 1 100' : 'M 0 1 L 100 1'}
          stroke="currentColor"
          strokeWidth="1px"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray={dashArray[variant]}
          vectorEffect="non-scaling-stroke"
        />
      </svg>
    </SeparatorPrimitive.Root>
  );
}
